import { api } from "../api/Middleware";
import { NOTIFICATIONS_URL } from "../api/Urls";

const NotificationService = {
  /**
   * Obter a configuração atual de notificação
   */
  getCurrentConfig: async () => {
    try {
      const response = await api.get(`${NOTIFICATIONS_URL}current/`);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar configuração de notificação:", error);
      throw error;
    }
  },

  /**
   * Salvar uma nova configuração
   */
  saveConfig: async (config) => {
    try {
      const response = await api.post(`${NOTIFICATIONS_URL}`, config);
      return response.data;
    } catch (error) {
      console.error("Erro ao salvar configuração de notificação:", error);
      throw error;
    }
  },

  /**
   * Atualizar uma configuração existente
   */
  updateConfig: async (id, config) => {
    try {
      const response = await api.put(`${NOTIFICATIONS_URL}${id}/`, config);
      return response.data;
    } catch (error) {
      console.error("Erro ao atualizar configuração de notificação:", error);
      throw error;
    }
  },
  /**
   * Deletar uma configuração existente
   */
  deleteConfig: async (id) => {
    try {
      const response = await api.delete(`${NOTIFICATIONS_URL}${id}/`);
      return response.data;
    } catch (error) {
      console.error("Erro ao deletar configuração de notificação:", error);
      throw error;
    }
  },

  sendWhatsapp: async () => {
    try {
      const response = await api.post(
        `${NOTIFICATIONS_URL}send_wa_for_human_request/`
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao tentar enviar a notificação!", error);
      throw error;
    }
  },
};

export default NotificationService;
